import styled from "styled-components";

export default styled.p`
    color: white;
    font-family: 'Inter', sans-serif;
    font-size: 11pt;
    text-align: left;
    max-width: 700px;
    margin: 0 auto;
    line-height: 1.75;
    
    @media only screen and (min-width: 600px) {
        font-size: 12pt;
    }
`;